import { COUNTRY_CODES } from "../../../constants/countries";

export const DENOMINACIONES_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        currencySymbol: "$",
        bills: [100, 50, 20, 10, 5, 2, 1],
        coins: [0.5, 0.25, 0.10, 0.05, 0.01],
        useDefaultValues: true,
        defaultValues: {
            50: 1,
            20: 2,
            5: 1,
            1: 4,
            0.5: 1,
        },
        expectedDefaultTotal: 99.5,
    },
    [COUNTRY_CODES.PARAGUAY]: {
        currencySymbol: "₲",
        bills: [100000, 50000, 20000, 10000, 5000, 2000],
        coins: [1000, 500, 100, 50],
        useDefaultValues: false
    },
    [COUNTRY_CODES.PERU]: {
        currencySymbol: "S/",
        bills: [200, 100, 50, 20, 10],
        coins: [5, 2, 1, 0.50, 0.20, 0.10],
        useDefaultValues: false
    },
    [COUNTRY_CODES.HONDURAS]: {
        currencySymbol: "L",
        bills: [500, 200, 100, 50, 20, 10, 5, 2],
        coins: [1, 0.50, 0.20, 0.10, 0.05],
        useDefaultValues: false
    },
    [COUNTRY_CODES.BOLIVIA]: {
        currencySymbol: "Bs",
        bills: [200, 100, 50, 20, 10],
        coins: [5, 2, 1, 0.5, 0.2, 0.1],
        useDefaultValues: false
    },
    [COUNTRY_CODES.GUATEMALA]: {
        currencySymbol: "Q",
        bills: [200, 100, 50, 20, 10, 5, 1],
        coins: [1, 0.5, 0.25, 0.1, 0.05],
        useDefaultValues: false
    },
    [COUNTRY_CODES.ELSALVADOR]: {
        currencySymbol: "$",
        bills: [100, 50, 20, 10, 5, 1],
        coins: [0.25, 0.1, 0.05, 0.01],
        useDefaultValues: false
    }
};

export const getDenominacionesConfig = (pais) =>
    DENOMINACIONES_CONFIG[pais] || DENOMINACIONES_CONFIG[COUNTRY_CODES.ECUADOR];
